// Shared extractor for persona patterns + antipatterns.
//
// Seeded personas store these at
// `data.data.engineering_profile.current_state.{patterns,antipatterns}`.
// Older fixtures use the flatter `data.engineering_profile.current_state`
// shape. Forward-compat: when the backend surfaces them at the response
// root (`persona.patterns` / `persona.antipatterns`), top-level wins.

export interface PersonaBibleSlice {
  patterns: string[];
  antipatterns: string[];
}

export function patternsFor(persona: any): PersonaBibleSlice {
  const top = {
    patterns: Array.isArray(persona?.patterns) ? persona.patterns : [],
    antipatterns: Array.isArray(persona?.antipatterns) ? persona.antipatterns : [],
  };
  if (top.patterns.length > 0 || top.antipatterns.length > 0) return top;
  const cs =
    persona?.data?.data?.engineering_profile?.current_state ??
    persona?.data?.engineering_profile?.current_state ??
    {};
  return {
    patterns: Array.isArray(cs.patterns) ? cs.patterns : [],
    antipatterns: Array.isArray(cs.antipatterns) ? cs.antipatterns : [],
  };
}
